.ChartContainer {
  position: relative;
  height: 200px;
}
